import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
    providedIn: 'root'
})
export class CheckoutAccountService {
    readonly showAccountExistsError = signal(false);
    readonly showAccountCreationSuccess = signal(false);

    readonly showAccountCreationSuccess$ = toObservable(this.showAccountCreationSuccess);
}
